import './js/load-genres';
import './js/totop';
import './js/header';
import './js/newhero';
// import './js/hero';
import './js/weekly';
import './js/upcoming';
import './js/modal-poster';
import './js/modal-trailer';
import './js/ourteam';
import './js/footer';
